// extracted by mini-css-extract-plugin
export var carrierTab = "_4h-0";
export var carrierTabActive = "_4h-1 _4h-0";
export var carrierTabInactive = "_4h-2 _4h-0";
export var carrierTabLabel = "_4h-3";
export var carrierTabLabelActive = "_4h-4 _4h-3";
export var carrierTabLabelInactive = "_4h-5 _4h-3";
export var carrierTabPercentage = "_4h-6";
export var carrierTabPercentageActive = "_4h-7 _4h-6";
export var carrierTabPercentageInactive = "_4h-8 _4h-6";
export var carrierTabWinnable = "_4h-9";
export var carrierTabWinnableActive = "_4h-a _4h-9";
export var carrierTabWinnableInactive = "_4h-b _4h-9";
export var comparisonContainer = "_4h-d";
export var missingRateButton = "_4h-n";
export var missingRateButtonActive = "_4h-o _4h-n";
export var missingRateButtonInactive = "_4h-p _4h-n";
export var missingRateButtonLabel = "_4h-q";
export var missingRateButtonLabelActive = "_4h-r _4h-q";
export var missingRateButtonLabelInactive = "_4h-s _4h-q";
export var sidebar = "_4h-c";
export var strategyButton = "_4h-e";
export var strategyButtonActive = "_4h-f _4h-e";
export var strategyButtonDescription = "_4h-k";
export var strategyButtonDescriptionActive = "_4h-l _4h-k";
export var strategyButtonDescriptionInactive = "_4h-m _4h-k";
export var strategyButtonInactive = "_4h-g _4h-e";
export var strategyButtonLabel = "_4h-h";
export var strategyButtonLabelActive = "_4h-i _4h-h";
export var strategyButtonLabelInactive = "_4h-j _4h-h";
export var unitToggleButton = "_4h-t";
export var unitToggleButtonActive = "_4h-u _4h-t";
export var unitToggleButtonInactive = "_4h-v _4h-t";
export var unitToggleButtonLabel = "_4h-w";
export var unitToggleButtonLabelActive = "_4h-x _4h-w";
export var unitToggleButtonLabelInactive = "_4h-y _4h-w";